import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { uploadFileThunk } from "../store/slices/fileSlice";


const useFileUpload = (form, dispatch) => {
  const { loading } = useSelector((state) => state.file);

  const handleFileUpload = async (file) => {
  if (loading || !file) return;

  const values = form.getFieldsValue();

  const localMeta = {
    name: file.name,
    size: file.size,
  };

  const result = await dispatch(
    uploadFileThunk({
      file,
      processName: values.processName || "",
      subProcess: values.subProcess || "",
      fileName: values.fileName || file.name,
      localFileMeta: localMeta,
    })
  );

  if (uploadFileThunk.fulfilled.match(result)) {
    toast.success("File uploaded. Ready to submit.",{theme: "colored"});
  } else {
    toast.error(result.payload || "Upload failed!",{theme: "colored"});
  }
};


  return { handleFileUpload };
};

export default useFileUpload;
